import { Typography, Box, useTheme } from "@mui/material";
import { tokens } from "../theme";

const Header = ({ title, subtitle }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  return (
    <Box mb="30px">
      <Typography
        variant="h2"
        color="#ffffff"  // 흰색으로 변경
        fontWeight="bold"
        sx={{ 
          m: "0 0 5px 0",
          textShadow: "0 2px 4px rgba(0,0,0,0.3)",  // 텍스트 그림자 추가
          letterSpacing: "0.5px"  // 글자 간격 약간 넓게
        }}
      >
        {title}
      </Typography>
      <Typography 
        variant="h5" 
        color="rgba(255,255,255,0.8)"  // 약간 투명한 흰색으로 변경
        sx={{
          lineHeight: 1.5,
          letterSpacing: "0.2px"
        }}
      >
        {subtitle}
      </Typography>
    </Box>
  );
};

export default Header;